import Api from '@/services/Api';

export default {
    getFoodList(data: {search?: string, limit?: string, order?: string}) {
        return Api().get(`foodname/${data.search || ''}` +
          `?limit=${data.limit || '50'}` +
          `${data.order ? '&order=' + data.order : ''}`, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'bearer ' + window.localStorage.getItem('token')
            }
        });
    },
    updateFoodEntry(id: string, params: object) {
        return Api().post('foodname/' + id, params, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-type': 'application/json',
              'Authorization': 'bearer ' + window.localStorage.getItem('token')
            }
        });
    },
    getIngredientInfo(id: string) {
        return Api().get('foodname/' + id, {
            headers: {
                'Access-Control-Allow-Origin': '*',
              'Authorization': 'bearer ' + window.localStorage.getItem('token')
            }
        });
    },
    getMeasures(foodId: string) {
        return Api().get('foodname/measures/' + foodId, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Authorization': 'bearer ' + window.localStorage.getItem('token')
          }
        });
    },
    getFoodTags() {
        return Api().get('tags/food', {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Authorization': 'bearer ' + window.localStorage.getItem('token')
          }
        });
    },
    getNutrients() {
        return Api().get('foodname/nutrients', {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Authorization': 'bearer ' + window.localStorage.getItem('token')
          }
        });
    },
    searchByTag(id: string) {
      return Api().get(`foodname/tags/${id}`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Authorization': 'bearer ' + window.localStorage.getItem('token')
        }
      });
    },
    addFoodTag(tagName: string) {
      return Api().post('tags/create/food', {name: tagName}, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Authorization': 'bearer ' + window.localStorage.getItem('token')
        }
      });
    },
    deleteTag(tagName: string) {
      return Api().delete(`tags/${tagName}`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Authorization': 'bearer ' + window.localStorage.getItem('token')
        }
      });
    },
    removeTag(tag: string, foodid: string) {
      return Api().delete(`tags/food/${tag}/${foodid}`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Authorization': 'bearer ' + window.localStorage.getItem('token')
        }
      });
    },
    addTagToFood(tag: string, food: string) {
      return Api().post('tags/tagfood', {tag, food}, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'application/json',
          'Authorization': 'bearer ' + window.localStorage.getItem('token')
        }
      });
    },
    addTagToMeal(tag: string, meal: string) {
      return Api().post('tags/tagmeal', {tag, meal}, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'application/json',
          'Authorization': 'bearer ' + window.localStorage.getItem('token')
        }
      });
    },
    createFood(food: object, nutrients: any) {
      return Api().post('foodname/create', {food, nutrients}, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'application/json',
          'Authorization': 'bearer ' + window.localStorage.getItem('token')
        }
      });
    },
    deleteFood(id: string) {
      return Api().delete(`foodname/${id}`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Authorization': 'bearer ' + window.localStorage.getItem('token')
        }
      });
    },
    getNutrientTargets(diet: string) {
      return Api().get(`nutrients/targets/${diet}`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Authorization': 'bearer ' + window.localStorage.getItem('token')
        }
      });
    }
};
